import { Table } from "@tanstack/react-table";
import { Account } from "@common/types/domains/accounting/account";
import { ImportedAccount } from "@common/schemas/domains/accounting/importedAccount.schema";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { isRowShowingMappingLoading } from "../../accountMappingLoadingState";
import { resolveMappedKickAccount } from "../../resolveMappedKickAccount";
import { CoaMappingRow } from "../coaMappingRowTypes";
import {
    CoaMappingTableCallbacks,
    CoaMappingTableOptions,
} from "../coaMappingTableMeta";

interface CoaMappingCellData {
    account: ImportedAccount | undefined;
    kickAccount: Account | undefined;
    isMappingLoading: boolean;
    options: CoaMappingTableOptions | undefined;
    callbacks: CoaMappingTableCallbacks | undefined;
}

export function useCoaMappingCellData({
    row,
    table,
}: {
    row: CoaMappingRow;
    table: Table<ViewTableFeatures, CoaMappingRow>;
}): CoaMappingCellData {
    const { options, callbacks } = useViewTableMeta<
        CoaMappingTableCallbacks,
        CoaMappingTableOptions
    >(table);
    const account = row.account;
    const kickAccount =
        account && options
            ? resolveMappedKickAccount({
                  account,
                  kickAccountsById: options.kickAccountsById,
              })
            : undefined;
    const isMappingLoading =
        !!account &&
        !!options &&
        isRowShowingMappingLoading({
            row: {
                kickAccountId: kickAccount?.id ?? null,
                createNewAccount: account.createNewAccount,
            },
            isAccountsMappingRunning: options.isAccountsMappingRunning,
        });
    return { account, kickAccount, isMappingLoading, options, callbacks };
}
